<template>
<digi-input 
    type="tel"
    label="Mobile phone number"
    :name="name"
    :rules="this.$getValidationRules(this.name)"
    :custom-messages="this.$getValidationMessages(this.name)"
    v-model="thisValue"
    :attributes="{ 'maxlength': 13 }"
    ></digi-input>
</template>

<script>
const nationalCodeRegex = /^(\+?44)/g;
export default {
    watch: {
        thisValue() {
            if (this.thisValue && nationalCodeRegex.test(this.thisValue)) {
                this.thisValue = this.thisValue.replace(nationalCodeRegex, 0);
                this.$emit('input', this.thisValue);
                return;
            }
            if (this.thisValue.length > 11) {
                this.thisValue = this.thisValue.substr(0, 11);
                this.$emit('input', this.thisValue);
                return;
            }
            this.$emit('input', this.thisValue);
        },
    },
    components: {
        'digi-input': () => import('./../../components/form/digi-input'),
    },
    data() {
        return {
            thisValue: this.value
        }
    },
    inject: [ '$getValidationRules', '$getValidationMessages' ],
    props: ['name', 'value'],
}
</script>

<style lang="scss">

</style>